import React from "react";
import AuthInputField from "../ui/input/AuthInputs";
import Step5CompanyAddStyle from "../../style/components/RegisterSteps/Step5CompanyAddress.module.css";
import mainstyle from "../../style/Main.module.css";

const Step5CompanyAddress = ({ formData, onChange, errors }) => {
  return (
    <div>
      <p>
        Provide the official location details of your company. This address will
        be used for official correspondence.
      </p>
      <div className={Step5CompanyAddStyle.Step5CompanyAddressDiv}>
        <label style={{ marginBottom: "0.5rem" }}>
          Address<span className={mainstyle.mantitory}>*</span>
        </label>
        <textarea
          className={Step5CompanyAddStyle.Step5CompanyAddressTextForm}
          value={formData?.company_address || ""}
          onChange={onChange}
          name="company_address"
        />
        {errors.company_address && (
          <span className={mainstyle.errorMsg}>{errors.company_address}</span>
        )}
      </div>

      <AuthInputField
        label="City"
        name="city"
        onChange={onChange}
        value={formData?.city || ""}
        error={errors.city}
        required
      />

      <AuthInputField
        label="State"
        name="state"
        onChange={onChange}
        value={formData?.state || ""}
        error={errors.state}
        required
      />

      <AuthInputField
        label="Pincode"
        name="pincode"
        value={formData?.pincode || ""}
        onChange={onChange}
        required
        error={errors.pincode}
      />
      {errors.error && (
        <div className={mainstyle.errorMsgCenter}>{errors.error}</div>
      )}
    </div>
  );
};

export default Step5CompanyAddress;
